module.exports = __webpack_public_path__ + "img/dis-yijihua.f9ab67a2.svg";